import {
    Action,
    createReducer,
    on
} from '@ngrx/store';
import * as DatiqAppActions from './datiq-app.actions';
import { IDatiqApp } from '@dat/datiq-core/models';

export const DATIQAPP_FEATURE_KEY = 'datiqApp';
export interface State extends IDatiqApp {
    loaded: boolean; // has the DatiqApp list been loaded
}

export interface DatiqAppPartialState {
    readonly [DATIQAPP_FEATURE_KEY]: State;
}

export const initialState: State = {
    loaded: false,
};

const datiqAppReducer = createReducer(
    initialState,
    on(DatiqAppActions.loaded, (state: State, { config }) => ({
        ...state,
        config: {...config, currentRoute: state.config?.currentRoute},
        loaded: true,
    })),
    on(DatiqAppActions.setRoute, (state: State, { route }) => ({
        ...state,
        config: { ...state.config, currentRoute: { ...route } },
        loaded: true,
    })),
    on(DatiqAppActions.loading, (state: State) => ({
        ...state,
        loaded: false,
    })),
    on(DatiqAppActions.unlockCurrentRoute, (state: State, {}) => ({
        ...state,
        config: {
            ...state.config,
            currentRoute: { ...state?.config?.currentRoute, locked: false },
        },
        loaded: true,
    })),
    on(DatiqAppActions.lockCurrentRoute, (state: State, {}) => ({
        ...state,
        config: {
            ...state.config,
            currentRoute: { ...state?.config?.currentRoute, locked: true },
        },
        loaded: true,
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return datiqAppReducer(state, action);
}
